import * as React from "react";
const MarineDocumentsView = React.lazy(() => import("./MarineDocumentsViewContainer"));

export { MarineDocumentsView };
